module.exports = __webpack_public_path__ + "img/uploader-icon.b18d46e0.svg";